<template>
  <div :class="['dash-card', fill ? 'dash-card-fill' : '']">
    <div class="dash-card-header">
      <div style="min-width: 0;">
        <h6 class="dash-card-title">
          <i v-if="icon" :class="['pi', icon]"></i>
          <span>{{ title }}</span>
        </h6>
        <p v-if="subtitle" class="dash-card-subtitle">{{ subtitle }}</p>
      </div>
      <div class="dash-card-tools">
        <slot name="tools"></slot>
        <span v-if="badge" class="dash-card-badge">{{ badge }}</span>
        <router-link v-if="actionTo" :to="actionTo" class="dash-card-link">
          {{ actionLabel || 'View all' }} <i class="pi pi-arrow-right"></i>
        </router-link>
        <a v-else-if="actionLabel" class="dash-card-link" @click="$emit('action')">
          {{ actionLabel }} <i class="pi pi-arrow-right"></i>
        </a>
      </div>
    </div>
    <div class="loading">
      <div v-show="loading" class="loading-bar"></div>
    </div>
    <div :class="['dash-card-body', noPadding ? 'no-padding' : '']">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="dash-card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardSectionCard',
  emits: ['action'],
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: '' },
    badge: { type: String, default: '' },
    actionLabel: { type: String, default: '' },
    actionTo: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    fill: { type: Boolean, default: false },
  },
};
</script>
